import type { WorshipService } from '../../shared/api/types';

const HOUR_MS = 60 * 60_000;

/** Misma regla que el backend (que es quien decide): abre 1 h antes y el registro propio cierra 1 h después. */
export function attendanceOpen(s: WorshipService, now = new Date()): boolean {
  return s.status !== 'canceled' && now.getTime() >= new Date(s.startsAt).getTime() - HOUR_MS;
}

export function selfCheckInOpen(s: WorshipService, now = new Date()): boolean {
  return attendanceOpen(s, now) && now.getTime() <= new Date(s.endsAt).getTime() + HOUR_MS;
}
